"use client";

import { useTranslations } from "next-intl";

/**
 * Props that make the element around a message's quick-reply chips a labelled group (welcome, unread peek,
 * operator / flow messages), so a screen reader announces them as one set of
 * answers. Spread on the existing container: a wrapper element would break its flex layout.
 */
export function useQuickReplyGroupProps(): { role: "group"; "aria-label": string } {
  const t = useTranslations("peek");
  return { role: "group", "aria-label": t("quickReplies") };
}
